/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */

import React, {useEffect, useState} from "react";
import {Redirect, Route} from "react-router-dom";
import axios from "axios";
import BASEURL from "./Constants";

const Auth = ({ component : Component, ...rest}) => {
    const [auth, setAuth] = useState(false);
    useEffect(()=>{
        const token = localStorage.admin_token
        if (token){
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
        let url = window.location.pathname
        if (url != '/login'){
            axios.post(BASEURL+'/api/client/check-auth').then(res=>{
                if (res.data.msg == true){
                    setAuth(res.data.msg)
                }else {
                    localStorage.removeItem('admin_token')
                    localStorage.removeItem('name')
                    localStorage.removeItem('email')
                }
            })
        }else{
            if (token){
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            }
        }

    },[])

    const token = localStorage.admin_token
    return(
        <Route
            {...rest}
            render={props=>
                token != undefined ? (
                    <Component {...props} />
                ):(
                    <Redirect
                        to={{
                            pathname:"/login",
                            state: {from: props.location}
                        }}
                    />
                )
            }
        />
    )
}
export default Auth